import { type ReactNode } from "react";

export function If<C extends boolean, T extends ReactNode>({ condition, children }: { condition: C, children: T }): C extends true ? T : null {
  if (condition) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- TypeScript cannot narrow conditional return types
    return children as C extends true ? T : null;
  } else {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- TypeScript cannot narrow conditional return types
    return null as C extends true ? T : null;
  }
}

export function isPouchError(err: unknown, err_name: string): boolean {
  if (err == null)
    return false;
  if (typeof err !== "object")
    return false;
  if (!("name" in err))
    return false;
  if (typeof err["name"] !== "string")
    return false;
  return err["name"] === err_name;
}

export interface ToStringable {
  toString(): string;
}

export function sortUniqueStrings(...iters: Iterable<ToStringable>[]): string[] {
  const s:Set<string> = new Set();
  for (const iter of iters)
    for (const item of iter)
      s.add(item.toString());
  return [...s].sort();
}

export * from "../common/utils";
